

import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Event, Router, NavigationStart, NavigationEnd, ActivatedRoute } from "@angular/router";
import { IdleTimer } from "./core/service/idletime.service";
import { TokenCookieService } from "./core/service/token-storage-cookies.service";
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
  MatSnackBar,
} from "@angular/material/snack-bar";
import { EMPTY, Subscription, interval, switchMap } from "rxjs";
import { AuthService } from "./core/service/auth.service";
import { NotificationService } from "./supplier-authentication/_service/notification.service";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [IdleTimer],
})
export class AppComponent implements OnInit, OnDestroy {

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
    }
  }

  currentUrl!: string;
  horizontalPosition: MatSnackBarHorizontalPosition = "end";
  verticalPosition: MatSnackBarVerticalPosition = "top";

  private routerEventsSubscription: Subscription;
  private tokenRefreshSubscription!: Subscription;

  private isUserIdle = false;
  private failedRefreshAttempts = 0;
  private currentUser: any;

  private idleTimerStarted = false;
  private tokenRefreshStarted = false;

  public countdown: number = 0;
  private countdownInterval: any;


  constructor(
    private tokenCookieService: TokenCookieService,
    private snackBar: MatSnackBar,
    private idleTimer: IdleTimer,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.snackBar.dismiss();
    this.routerEventsSubscription = this.router.events.subscribe(
      (routerEvent: Event) => {
        if (routerEvent instanceof NavigationStart) {
          this.currentUrl = routerEvent.url.substring(
            routerEvent.url.lastIndexOf("/") + 1
          );
        }

        if (routerEvent instanceof NavigationEnd) {
          this.currentUser = this.tokenCookieService.getUser();

          // if (this.currentUser !== null && this.currentUser !== undefined) {
          //   this.idleTimer.start({
          //     timeout: 60 * 5, // Set the timeout to 3 minutes
          //     onTimeout: () => {
          //       // Perform the action to be executed on timeout
          //       this.logout();
          //     },
          //   });
          // }

        }

        window.scrollTo(0, 0);
      }
    );
  }

  ngOnInit(): void {
    const user = this.tokenCookieService.getUser();

    if (user && user.refreshToken && !this.idleTimerStarted) {
      this.currentUser = user;
      this.setupIdleTimer();
      this.startTokenRefresh(user);
      this.idleTimerStarted = true;
      this.tokenRefreshStarted = true;
    }

    this.tokenCookieService.currentUser$.subscribe((user) => {
      if (user && user.refreshToken && !this.idleTimerStarted) {
        this.currentUser = user;
        this.setupIdleTimer();
        this.startTokenRefresh(user);
        this.idleTimerStarted = true;
        this.tokenRefreshStarted = true;
      }

      if ((!user || !user.refreshToken) && this.idleTimerStarted) {
        this.stopIdleTimer();
        this.stopCountdown();
        this.idleTimerStarted = false;
      }
    });
  }



  private setupIdleTimer(): void {
    const timeoutSeconds = 60 * 5;

    console.log("Idle timer starting...");

    this.idleTimer.start({
      timeout: timeoutSeconds,
      onTimeout: () => {
        console.log("Idle timer expired -> logging out...");
        this.isUserIdle = true;
        this.stopCountdown();
        this.logout();
      },
    });

    this.startCountdown(timeoutSeconds);

    this.listenToUserActivity();
  }

  private startCountdown(seconds: number): void {
    this.countdown = seconds;

    this.stopCountdown();

    this.countdownInterval = setInterval(() => {
      this.countdown--;
      // console.log(` Idle time left before logout: ${this.countdown}s`);

      if (this.countdown <= 0) {
        this.stopCountdown();
      }
    }, 1000);
  }

  private stopCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }


  private stopIdleTimer(): void {
    if (this.idleTimer?.stop) {
      this.idleTimer.stop();
    }
  }

  private listenToUserActivity(): void {
    const activityEvents = ["mousemove", "keydown", "click", "scroll"];

    activityEvents.forEach((event) => {
      window.addEventListener(event, () => {
        if (this.idleTimer?.reset) {
          this.idleTimer.reset();
          this.startCountdown(60 * 7);
        }
        this.isUserIdle = false;
      });
    });
  }
  private startTokenRefresh(user: any): void {
    if (this.tokenRefreshSubscription) {
      this.tokenRefreshSubscription.unsubscribe();
    }

    this.tokenRefreshSubscription = interval(1500000)
      .pipe(
        switchMap(() => {
          if (user && user.refreshToken && !this.isUserIdle) {
            return this.authService.refreshAccessToken(user.refreshToken);
          } else {
            return EMPTY;
          }
        })
      )
      .subscribe(
        (response) => {
          this.failedRefreshAttempts = 0;
          if (response) {
            this.tokenCookieService.saveUser(response);
            user = response; 
          }
        },
        (error) => {
          console.error("Token refresh failed:", error);
          this.failedRefreshAttempts++;

          if (this.failedRefreshAttempts >= 3) {
            this.logout();
          }
        }
      );
  }


  logout = () => {
    this.tokenCookieService.signOut().subscribe(
      (res) => {
        console.log("res: ", res);
        if (res) {
          this.router.navigate(["/authentication/signin"]);
          localStorage.clear();
          this.router.navigate([this.route.snapshot.url.join('/')]);
          this.snackBar.open(
            "Your session has ended: please sign in to resume!",
            "X",
            {
              horizontalPosition: this.horizontalPosition,
              verticalPosition: this.verticalPosition,
              duration: 60000,

              panelClass: ["snackbar-danger", "login-snackbar"],
            }
          );

          console.log("Session timed out!");
        }
      },
      (err) => {
        console.log(err);

      }
    );
  };

  ngOnDestroy(): void {
    this.routerEventsSubscription.unsubscribe();
  }

}
